import updateFieldProps from '@rwitl/reformed-util/lib/updateFieldProps'

const defaultReducerLogic = (productState, action) => {
  if (action.type == 'UPDATE_CONTROL'){
    productState = updateFieldProps(
      productState,
      action.fieldKey,
      action.propValues,
      action.nestedLayout
    )
  }
  return productState
}

export default defaultReducerLogic


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/editorReducer/defaultReducerLogic.js